// generalStore.js

// General site settings and config
import { writable } from 'svelte/store';
import { productStore } from './products';
import { untilLiveDraw, untilThursdayDraw, daysRemaining } from '$lib/helpers';
import { getPrizeCount } from '$lib/firestore/getPrizeCount';   

// Internal writable store (not exported)
const internalGeneralStore = writable({
  daysUntilMonday: null,
  daysUntilThursday: null,
  prizeCount: 0,
  filters: [],
});

// Function to fetch general data and update the store
async function fetchGeneralData() {
  // Get the current value of productStore
  let categories = [];
  const unsubscribe = productStore.subscribe(($productStore) => {
    categories = $productStore.flatMap((item) => {
      const cats = [];
      if (typeof item.category === 'string') cats.push(item.category);
      if (Array.isArray(item.categories)) cats.push(...item.categories);
      return cats;
    });
  });
  unsubscribe(); // Immediately unsubscribe to avoid unnecessary updates

  const uniq = Array.from(new Set(categories.filter(Boolean)));

  const monday = untilLiveDraw();
  const thursday = untilThursdayDraw();

  const [daysUntilMonday, daysUntilThursday, prizeCount] = await Promise.all([
    daysRemaining(monday),
    daysRemaining(thursday),
    getPrizeCount(),
  ]);

  const genObject = {
    filters: uniq,
    daysUntilMonday,
    daysUntilThursday,
    prizeCount,
  };

  internalGeneralStore.set(genObject);
}

// Immediately fetch general data to initialize the store
fetchGeneralData();

// Update the store whenever productStore changes
productStore.subscribe(() => {
  fetchGeneralData();
});

// Exported readable store
export const generalStore = {
  subscribe: internalGeneralStore.subscribe,
};

// Optionally, export fetchGeneralData if you need to trigger updates from elsewhere
// export { fetchGeneralData };
